// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_URL: 'https://api.blockchainx.tech/api',
  ETHEREUM_PROVIDER: 'https://holesky.infura.io/v3/3df86088496b4ef2ba618eb4764d0b7a',
  BINANCE_PROVIDER: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  ETH_CONTRACT_ADDRESS: '0x467159D4B29D7D6d1D1473caEbDc306298cE3269',
  ETH_BRIDGE_ADDRESS: '0x3593E39fbFC73800F635C57d766c959A00bf02f8',
  projectId: 'ce7c7bb0dcadf584586f578ba078becb',
  BSC_CONTRACT_ADDRESS: '0xc35beD7fb5183A8d01995cA4f70B29F54b5Ad194',
  BSC_BRIDGE_ADDRESS: '0x9b73A9b8c30496631CccC2F55F6f086C2fdf232a',
  SUPPORTED_NETWORK:[17000,97],
  WEB_SITE_URL:'https://www.blockchainx.tech',
  SUPPORTED_CHAINS: ['17000','97'],
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// Ethereum Side Contract Addresses:
// old token - 0x039a19d716c6ade855241e2d94d01195ab094dc9
// Migrator - 0x470B46D30ae5b9338908C9F6e991e6006565AABD
// New token - 0xD0daD90122a5772B6d5a03916b80A7dfAa2e2EEb
// Bridge ETH - 0x06bA4D344eA7028C97e94674CE15Ca0381311253

// Binance Contract Addresses:
// BridgeBsc: 0xaA13e6040BC6414D91eC0c4D7Ac4800f4a472B37
// Bep-20 : 0x4C6Fc31d0ceBB562AF6328862aD0C5941638D75f